module.exports = __webpack_public_path__ + "files/ab9ac36961e6bac117ea08e368a13d0e.png";